import * as baseColors from "./commoncss/zfc_ui_base_colors.css";
import * as baseIcons from "./commoncss/zfc_ui_icons.css";
import * as baseOthers from "./commoncss/zfc_ui_others.css";
import * as normalizeCss from "normalize.css/normalize.css";
import * as globalCss from "./commoncss/global.css";
import * as headerCss from "./zfc_header.css";
import * as footerCss from "./zfc_footer.css";
import * as sideNaveCss from "./zfc_sidenav.css";
import * as separatorCss from "./zfc_separator.css";
import * as sectionWrapperCss from "./zfc_section_wrapper.css";
import * as breadcrumbCss from "./zfc_breadcrumb.css";
import * as swiperCss from "./zfc_swiper.css";
import * as contactCss from "./zfc_contact.css";
import * as ctaCss from "./zfc_cta.css";
import * as conetentGroupCss from "./zfc_content_group.css";
import * as teaserNewsletterCss from "./zfc_teaser_newsletter.css";
import * as corporateStageCss from "./zfc_corporate_stage.css";
import "swiper/css";
import 'swiper/css/effect-fade';
import 'swiper/css/effect-creative';
import 'swiper/css/pagination';
import * as tableCss from "./zfc_table.css";
import * as pressCss from "./zfc_press.css";
import * as baseButtons from "./commoncss/zfc_ui_buttons.css";
import * as baseForm from "./commoncss/zfc_ui_form.css";
import * as baseSeparators from "./commoncss/zfc_ui_separators.css";
import * as awesompleteCss from "awesomplete/awesomplete.css";
import * as certificateFilterCss from "./zfc_certificate_filter.css";
import * as eventCalendarCss from "./zfc_event_calendar.css";
import * as searchListCss from "./zfc_search_list_result.css";
import * as searchFilterCss from "./zfc_search_filter.css";
import * as filterToolCss from "./zfc_filtertool.css";
import * as productFinderCss from "./zfc_product_finder.css";
import * as articleCss from "./zfc_article.css";
import * as accordionCss from "./zfc_accordion.css";
import * as tileNavCss from "./zfc_tile_navigation.css";
import * as anchorNavCss from "./zfc_anchor_navigation.css";
import * as linkListCss from "./zfc_link_list.css";
import * as productFinderStageCss from "./zfc_product_finder_stage.css";
import * as teaserFlexCss from "./zfc_teaser_flex.css";
import * as galleryCss from "./zfc_gallery.css";
import * as searchStageCss from "./zfc_search_stage.css";
import * as conetentImageCss from "./zfc_content_image.css";
import * as locationBlockCss from "./zfc_location_block.css";
import * as textMediaCss from "./zfc_text_media.css";
import * as teaserTileCss from "./zfc_teaser_tile.css";
import * as counterTileCss from "./zfc_counter_tile.css";
import * as videoCss from "./zfc_video.css";
import * as nextTeaserCss from "./zfc_next_teaser.css";
import * as generalSliderCss from "./zfc_general_slider.css";
import * as selectRegionCss from "./zfc_select_region.css";
import * as formcentricFlexCss from "./commoncss/formcentric_flex.css";
import * as teaserKeyTopicCss from "./zfc_teaser_key_topic.css";
export * from "./zf_auto_lang_switch";
export * from "./zf_translations";
export * from "./zf_utils";
export * from "./zfc_global";
export * from "./zfc_header";
export * from "./zfc_footer";
export * from "./zfc_video";
export * from "./zfc_corporate_stage";
